import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { CategoriesPage } from '../../features/catalog/categories-page'

export const Route = createFileRoute('/_app/product-categories')({
  staticData: { crumb: 'productCategories' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.read'),
  component: CategoriesPage,
})
